module.exports = __webpack_public_path__ + "img/model_mt11_small.09dea17f.png";